
















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
  // @Prop() public avatar!: string;
  private key: string = '';

  public created() {
    this.key = this.$store.state.searchKeywords;
  }
  private toUser() {
    this.$router.push({ name: 'center'});
  }
  private toSearch() {
    if (this.key.trim() === '') {
      return !1;
    }
    this.$router.push({ path: 'search', query: {keywords: this.key} });
  }
  get avatar() {
    return this.$store.state.userInfo.avatar;
  }
}
